import React, { forwardRef } from "react";

import { useTheme } from "../../utils/theme";
import { Button } from "../Button";

import type { StyleProp, View, ViewStyle } from "react-native";
import type { TestProps } from "../../types";
import type { ButtonProps } from "../Button";

export interface DialogActionProps extends TestProps {
  text: string;
  onPress?: () => void;
  type?: "primary" | "cancel" | "destructive";
  disabled?: ButtonProps["disabled"];
  isLoading?: ButtonProps["isLoading"];
  style?: StyleProp<ViewStyle>;
}

export const DialogAction = forwardRef(function DialogAction(
  {
    text,
    onPress,
    type,
    disabled,
    isLoading,
    testID,
    style,
  }: DialogActionProps,
  ref: React.Ref<View>
) {
  const { colors } = useTheme();

  const backgroundColor =
    type === "destructive"
      ? { backgroundColor: colors.errorPrimary }
      : undefined;

  return (
    <Button
      variation={type === ("cancel" || "destructive") ? "plain" : undefined}
      ref={ref}
      testID={testID}
      onPress={onPress}
      isLoading={isLoading}
      contentStyle={backgroundColor}
      textStyle={
        type === "destructive"
          ? {
              color: colors.white,
            }
          : undefined
      }
      disabled={disabled}
      style={[backgroundColor, style]}
    >
      {text}
    </Button>
  );
});
